export default __webpack_public_path__ + "static/media/sasuke-eye.ede17472.png";